var CustomFieldType;
(function (CustomFieldType) {
    CustomFieldType["Text"] = "text";
    CustomFieldType["Select"] = "select";
    CustomFieldType["Checkbox"] = "checkbox";
    CustomFieldType["Radio"] = "radio";
    CustomFieldType["Datetime"] = "datetime";
    CustomFieldType["File"] = "file";
})(CustomFieldType || (CustomFieldType = {}));
var CustomFieldEntityType;
(function (CustomFieldEntityType) {
    CustomFieldEntityType["User"] = "user";
    CustomFieldEntityType["Pipeline"] = "pipeline";
    CustomFieldEntityType["Users"] = "users";
    CustomFieldEntityType["Task"] = "task";
})(CustomFieldEntityType || (CustomFieldEntityType = {}));
export { CustomFieldEntityType, CustomFieldType };
